var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesign(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 153,
    viewBox: "0 0 175 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M114.591 47.6553C114.18 45.2984 111.922 42.864 109.81 41.6856C109.59 41.5564 109.371 41.4394 109.151 41.3231C104.37 44.2471 95.6302 48.9765 85.3653 50.414C84.5737 50.5303 83.6058 50.3617 83.0045 50.8411C81.1133 52.3303 80.7322 57.5364 76.0545 57.6526C75.4084 59.1038 74.8224 60.5018 74.1918 61.6932C74.9564 60.7473 80.5443 61.6442 81.9634 61.9264C83.3556 62.1984 89.3608 63.6434 89.1052 64.7756C90.1608 62.7676 89.7504 60.7351 89.0613 58.6108C97.4343 57.1868 109.034 51.9549 114.591 47.6553Z",
    fill: "#2D825F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3598 69.5023C39.8705 70.7665 37.9902 71.6123 35.9566 71.9327C33.923 72.2531 31.8274 72.0338 29.935 71.3025C28.0426 70.5711 26.4382 69.3606 25.3248 67.824C24.2114 66.2874 23.6389 64.4938 23.6798 62.6699C23.7208 60.846 24.3732 59.0737 25.5547 57.5773C26.7361 56.0808 28.3935 54.9274 30.3173 54.2628C32.2411 53.5983 34.3448 53.4525 36.3624 53.8438C38.38 54.2351 40.221 55.146 41.6524 56.4613C42.6037 57.3341 43.3508 58.364 43.851 59.492C44.3512 60.6201 44.5946 61.8242 44.5675 63.0354C44.5404 64.2466 44.2431 65.4412 43.6926 66.5508C43.1422 67.6605 42.3495 68.6635 41.3598 69.5023Z",
    fill: "#2D825F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M153.597 105.749C154.652 102.524 158.172 103.508 160.108 101.566C160.46 104.532 158.612 107.51 155.268 107.652L153.597 105.749Z",
    fill: "#C6E84F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0155 112.133C72.6811 112.82 70.1886 111.395 67.4612 108.675C67.5089 109.613 67.8104 110.529 68.3406 111.343C70.1886 114.399 70.1008 121.936 72.1536 121.407C72.7257 121.252 73.4003 118.687 74.0016 115.748C74.3129 114.329 74.7243 112.927 75.2336 111.552C74.9788 111.667 74.2711 111.983 74.0155 112.133Z",
    fill: "#C6E84F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5502 47.1895C82.8194 47.8808 83.2159 48.5283 83.7237 49.1057C85.0134 48.9377 86.4471 48.5923 86.7143 48.0701C86.7611 47.9821 86.8004 47.8912 86.8321 47.7981C86.4949 48.7433 84.5445 48.1088 82.5502 47.1895Z",
    fill: "#C6E84F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2804 40.2351C81.6847 37.8266 73.2239 39.717 67.4905 43.3822C61.7278 47.0596 63.3849 50.5045 70.8485 48.9248C70.4088 49.0411 65.6279 50.31 62.5048 53.4808C57.9148 58.1429 61.9034 59.93 67.0478 58.9977C73.1916 57.8838 78.4707 53.4292 80.2594 50.3467C81.081 48.5306 81.6383 46.6298 81.918 44.6898C79.7774 43.1489 81.0825 41.7502 82.2553 42.8123C82.8859 43.3822 83.5897 43.1102 82.8127 41.2483C83.5958 40.8192 84.536 40.6819 84.2804 40.2351Z",
    fill: "#C6E84F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M103.857 115.526C103.586 112.451 103.625 109.361 103.974 106.292C101.192 106.986 98.2405 106.946 95.4839 106.176C95.5424 108.326 94.7801 109.414 95.4107 110.748C95.7895 111.496 96.327 112.172 96.9938 112.741C99.7512 115.202 102.112 122.454 103.915 121.418C104.414 121.132 104.223 118.504 103.857 115.526Z",
    fill: "#C6E84F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2739 61.2791C76.142 61.8801 75.9355 62.4664 75.6579 63.0274C73.2678 61.9781 73.8253 61.292 76.2739 61.2791Z",
    fill: "#C6E84F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1198 64.76C89.0605 65.0061 88.6647 65.1619 88.0049 65.236C88.2543 64.8348 88.4746 64.4717 88.6647 64.1092C89.002 64.3608 89.1629 64.5811 89.1198 64.76Z",
    fill: "#C6E84F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6887 84.6276L94.1487 88.5253C94.0902 87.0103 94.0316 85.5211 94.0016 84.0577L95.6887 84.6276Z",
    fill: "#C6E84F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0261 112.146C39.0883 106.193 33.8631 101.123 31.3945 101.963C28.0534 103.1 32.5864 112.217 35.1859 116.199C39.5557 122.882 44.8348 127.414 47.037 126.368C50.2379 124.793 45.0088 115.143 43.0261 112.146Z",
    fill: "white",
    fillOpacity: 0.38
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1008 98.1215C65.7603 91.4908 60.4958 87.0103 58.3252 88.1255C56.1407 89.2386 57.9002 95.5069 62.226 102.137C66.5519 108.767 71.831 113.235 74.0009 112.133C76.1861 111.02 74.4267 104.751 70.1008 98.1215Z",
    fill: "white",
    fillOpacity: 0.39
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2329 111.55C74.725 112.925 74.3136 114.327 74.0009 115.746C73.4064 118.687 72.7265 121.254 72.1529 121.405C70.1039 121.949 70.1809 114.401 68.3398 111.341C67.8085 110.527 67.5069 109.612 67.4605 108.673",
    stroke: "#1C191A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M125.984 62.82C125.692 62.4018 125.299 62.0455 124.833 61.7764C124.367 61.5072 123.841 61.3318 123.289 61.2626C122.738 61.1934 122.177 61.232 121.645 61.3757C121.113 61.5195 120.622 61.7648 120.209 62.0944C120.046 61.6025 119.756 61.1504 119.363 60.7734C118.97 60.3963 118.483 60.1044 117.941 59.9202C117.4 59.736 116.817 59.6646 116.238 59.7115C115.66 59.7583 115.103 59.9222 114.608 60.1904C114.179 60.4232 113.808 60.7283 113.513 61.0883C113.219 61.4483 113.008 61.8561 112.892 62.2882C112.283 61.8828 111.55 61.6492 110.788 61.6182C110.027 61.5872 109.272 61.7601 108.624 62.1143C107.976 62.4685 107.464 62.9874 107.155 63.6031C106.846 64.2187 106.756 64.9024 106.894 65.5644C106.399 65.4499 105.883 65.4242 105.378 65.4888C104.871 65.5534 104.385 65.707 103.947 65.9405C103.453 66.2085 103.035 66.5731 102.726 67.0062C102.416 67.4394 102.224 67.9295 102.163 68.4387C102.102 68.948 102.174 69.4628 102.375 69.9435C102.574 70.4242 102.897 70.8579 103.316 71.2112C102.802 71.3901 102.338 71.6662 101.958 72.02C101.578 72.3738 101.289 72.7969 101.113 73.2594C100.937 73.722 100.878 74.213 100.939 74.6979C101 75.1829 101.181 75.6502 101.468 76.067C101.869 76.6528 102.469 77.1129 103.182 77.3822C103.895 77.6514 104.685 77.7167 105.442 77.5692L125.913 66.4852C126.428 66.2111 127.054 64.3452 125.984 62.82Z",
    stroke: "#1C191A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M110.456 67.9608C110.939 68.3633 111.251 68.9006 111.339 69.4824C111.427 70.0642 111.285 70.6549 110.937 71.1551C110.589 71.6553 110.057 72.0344 109.43 72.2287C108.803 72.4229 108.119 72.4205 107.494 72.2216",
    stroke: "#1C191A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M119.576 65.6821C119.495 66.206 119.233 66.6948 118.825 67.0819C118.417 67.4688 117.883 67.7351 117.298 67.8443C116.712 67.9534 116.102 67.9 115.552 67.6914C115.002 67.4828 114.538 67.1292 114.224 66.679C114.091 66.4845 113.988 66.2756 113.916 66.0574",
    stroke: "#1C191A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M120.207 62.0944C119.813 62.4228 119.486 62.8085 119.239 63.2348",
    stroke: "#1C191A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M104.651 70.9929C104.196 71.0131 103.747 71.0867 103.314 71.2118",
    stroke: "#1C191A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M112.89 62.2889C112.793 62.7109 112.778 63.144 112.843 63.5707",
    stroke: "#1C191A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M108.345 66.1656C107.906 65.8906 107.413 65.6873 106.892 65.5651",
    stroke: "#1C191A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M131.205 70.3047C130.117 68.7224 127.872 68.4402 127.48 68.6992L106.995 79.7975C106.409 80.1083 105.604 81.9885 106.717 83.5783C107.006 83.9938 107.395 84.3488 107.855 84.6174C108.317 84.8866 108.839 85.0628 109.385 85.1342C109.932 85.2049 110.49 85.1695 111.019 85.0301C111.548 84.8907 112.037 84.6507 112.45 84.3263C112.685 85.0396 113.184 85.6632 113.866 86.0977C114.548 86.5322 115.375 86.7526 116.216 86.7247C117.057 86.6961 117.863 86.4207 118.506 85.9413C119.149 85.4626 119.592 84.8071 119.765 84.0802C120.37 84.4895 121.102 84.7282 121.863 84.7642C122.625 84.801 123.381 84.633 124.033 84.2828C124.685 83.9326 125.201 83.4172 125.515 82.8031C125.829 82.1891 125.925 81.5057 125.792 80.8427C126.604 81.0242 127.462 80.9624 128.23 80.6672C128.999 80.3714 129.635 79.8587 130.038 79.21C130.44 78.5606 130.587 77.8119 130.456 77.0802C130.324 76.3494 129.921 75.6777 129.311 75.1708C129.831 74.9966 130.301 74.7236 130.688 74.3708C131.075 74.0182 131.37 73.5946 131.551 73.1301C131.731 72.6656 131.794 72.1717 131.734 71.6834C131.675 71.1951 131.494 70.7244 131.205 70.3047Z",
    stroke: "#1C191A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M118.96 80.2116C118.809 79.7608 118.522 79.3555 118.127 79.04C117.733 78.7245 117.249 78.511 116.726 78.4226C116.203 78.3342 115.663 78.375 115.165 78.5395C114.667 78.7048 114.23 78.987 113.901 79.3569C113.58 79.722 113.373 80.1552 113.3 80.6128",
    stroke: "#1C191A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M125.398 74.076C124.834 73.9039 124.223 73.8897 123.648 74.0353C123.075 74.1811 122.565 74.4795 122.19 74.89C121.815 75.3006 121.591 75.8033 121.552 76.3297C121.512 76.856 121.657 77.3808 121.966 77.8316C122.099 78.0275 122.262 78.2063 122.451 78.3627",
    stroke: "#1C191A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M129.313 75.1742C128.796 75.3428 128.25 75.4305 127.7 75.4333",
    stroke: "#1C191A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M113.262 83.392C113.042 83.7374 112.769 84.0536 112.45 84.3324",
    stroke: "#1C191A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M125.794 80.8461C125.322 80.7264 124.876 80.5394 124.472 80.2926",
    stroke: "#1C191A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M119.809 82.6964C119.879 83.1581 119.864 83.6259 119.767 84.0836",
    stroke: "#1C191A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M106.995 79.7975L104.81 80.9624",
    stroke: "#1C191A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M105.441 77.5698L103.285 78.7224",
    stroke: "#1C191A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0763 86.7254L70.79 99.2088",
    stroke: "#1C191A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6066 83.9149L69.3085 96.956",
    stroke: "#1C191A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M114.283 47.8885C119.498 47.4625 124.742 48.3762 129.382 50.5197C134.023 52.6631 137.865 55.9451 140.443 59.9708C148.233 71.7926 144.152 87.0606 131.337 94.068C123.32 98.4513 121.096 96.1338 105.529 100.052",
    stroke: "#1C191A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1687 112.032C81.2897 108.753 87.6537 105.886 94.208 103.521",
    stroke: "#1C191A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9834 77.0905C70.0423 80.587 64.6307 83.9931 58.3106 88.1112",
    stroke: "#1C191A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2169 56.7591C93.1438 60.8395 89.6958 64.6899 85.9081 68.2715",
    stroke: "#1C191A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M109.136 41.336C111.614 42.5662 114.136 45.0917 114.591 47.6553C109.033 51.9549 97.4343 57.1868 89.0613 58.6108C89.7504 60.7351 90.1608 62.7683 89.1052 64.7756C89.3608 63.6448 83.4434 62.2182 81.9634 61.9264C80.5189 61.6415 74.9503 60.7562 74.1918 61.6932C74.8224 60.5018 75.4092 59.1031 76.0545 57.6526C80.7322 57.5364 81.1056 52.3228 83.0045 50.8411C83.6028 50.3746 84.5445 50.531 85.3653 50.414C95.624 48.9405 104.37 44.2498 109.151 41.3231L109.136 41.336Z",
    stroke: "#1C191A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0311 63.9984C79.2292 63.9394 83.3637 64.9092 86.9754 66.8",
    stroke: "#1C191A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7644 47.9361C86.2862 48.6746 84.4382 48.0599 82.5502 47.1881C82.8192 47.8795 83.2158 48.527 83.7237 49.1044",
    stroke: "#1C191A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8217 50.4623C83.7999 50.2406 84.0732 49.8014 83.7236 49.1057C86.4802 48.746 86.9576 48.2979 86.8445 47.078C86.6789 45.3059 85.5008 41.4448 84.2804 40.2351",
    stroke: "#1C191A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0613 58.6108C88.2104 58.7536 87.3896 58.8569 86.6266 58.9222",
    stroke: "#1C191A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8143 41.2456C83.5912 43.1102 82.8913 43.3822 82.2568 42.8096C81.0833 41.7481 79.7789 43.1496 81.9195 44.6871C81.6405 46.6277 81.0837 48.5292 80.2625 50.346C78.4738 53.4285 73.1947 57.8832 67.0508 58.997C61.9034 59.9293 57.9148 58.1422 62.5078 53.4802C65.631 50.3073 70.4119 49.0384 70.8516 48.9242C63.388 50.5038 61.7325 47.061 67.4936 43.3815C73.2286 39.7183 81.6878 37.8259 84.2834 40.2344C84.5314 40.6778 83.5681 40.8342 82.8143 41.2456Z",
    stroke: "#1C191A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0545 57.6526C76.8289 55.8021 77.827 54.0307 79.0313 52.369C79.5074 51.74 79.9148 51.0723 80.2479 50.3753",
    stroke: "#1C191A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9305 68.2511C86.9474 66.9287 87.8632 65.548 88.6724 64.1181",
    stroke: "#1C191A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M117.788 40.7016C120.001 40.2351 121.824 41.1164 121.673 41.8671C121.639 42.0176 121.569 42.16 121.468 42.2849C121.367 42.4099 121.237 42.5145 121.087 42.592",
    stroke: "#1C191A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M117.582 39.5102C119.914 39.0179 122.231 40.0542 121.233 41.1422",
    stroke: "#1C191A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M114.341 46.723C115.721 45.3321 117.491 44.287 119.474 43.6929",
    stroke: "#1C191A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M117.699 42.0997C119.855 41.7114 121.275 42.4621 121.19 43.2006C121.084 44.107 119.034 45.48 117.303 44.5994",
    stroke: "#1C191A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M115.881 38.8234C115.91 38.7976 116.805 37.6974 116.409 37.3472C116.072 37.0493 111.203 40.5846 109.84 41.7114",
    stroke: "#1C191A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M118.682 39.3804C122.553 37.7361 123.593 35.7526 122.861 36.1164C120.42 37.1955 117.913 38.1553 115.353 38.9914C113.371 39.6573 111.509 40.5735 109.825 41.7114",
    stroke: "#1C191A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M103.974 106.292C103.628 109.361 103.589 112.451 103.857 115.526C104.23 118.504 104.414 121.133 103.915 121.418C102.11 122.453 99.7458 115.207 96.9938 112.741C96.3255 112.173 95.788 111.496 95.4107 110.748C94.7785 109.412 95.5447 108.322 95.4831 106.165",
    stroke: "#1C191A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1008 98.1215C74.4321 104.749 76.1877 111.022 74.0009 112.129C71.8325 113.232 66.5519 108.763 62.226 102.133C57.9002 95.5042 56.1423 89.24 58.3252 88.1241C60.5082 87.0082 65.7657 91.4881 70.1008 98.1215Z",
    stroke: "#1C191A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M47.844 122.718C46.7475 116.691 40.1563 106.664 34.8048 103.043C32.0405 101.152 30.0608 101.486 30.2872 104.658C30.7169 110.676 38.3052 122.286 43.9693 125.693C47.114 127.583 48.4661 126.139 47.844 122.718Z",
    stroke: "#1C191A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1825 126.3L51.5361 124.076C51.9555 123.785 52.2407 123.37 52.3379 122.907C52.4352 122.445 52.3378 121.967 52.0643 121.563C53.7968 123.868 57.1964 121.488 55.8327 119.491C57.0978 121.395 61.0756 120.166 59.4402 117.277C59.8108 117.701 60.3391 117.996 60.9319 118.109C61.5246 118.224 62.1439 118.149 62.6803 117.899C64.4513 116.9 63.7945 114.959 62.6957 111.799C60.6404 106.372 57.38 101.361 53.1054 97.06C52.078 95.9795 50.9019 95.0159 49.6042 94.1931C47.5521 93.0691 45.2437 93.9116 46.0375 96.9696C45.3846 96.0087 44.6184 95.3804 43.3241 95.6871C42.9973 95.7673 42.696 95.9135 42.4438 96.1134C42.1916 96.314 41.9953 96.5629 41.8704 96.8417C41.7454 97.1198 41.6952 97.4204 41.7237 97.7189C41.7521 98.0174 41.8585 98.3058 42.0343 98.5621C42.0343 98.5621 40.5151 96.8662 38.7934 98.0705C38.3658 98.3649 38.0778 98.7892 37.9855 99.2605C37.8933 99.7324 38.0034 100.217 38.2944 100.621C38.1558 100.405 37.9701 100.216 37.748 100.064C37.526 99.9112 37.272 99.7997 37.0007 99.7344C36.7294 99.6692 36.4463 99.6528 36.1675 99.6848C35.8888 99.7168 35.6201 99.7977 35.3769 99.9221L31.279 102.004",
    stroke: "#1C191A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M153.597 105.749C151.788 106.631 150.054 107.627 148.406 108.727C143.566 112.029 138.845 116.173 139.474 116.899C140.103 117.625 145.825 114.648 150.677 111.343C152.303 110.215 153.832 108.981 155.252 107.652",
    stroke: "#1C191A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M153.597 105.749C154.652 102.524 158.172 103.508 160.108 101.566C160.46 104.532 158.612 107.51 155.268 107.652L153.597 105.749Z",
    stroke: "#1C191A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M149.014 108.321L151.28 110.916",
    stroke: "#1C191A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M157.043 43.7188L155.122 47.5193H158.641L156.705 51.3205",
    stroke: "#1C191A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6647 137.593L80.8639 137.799",
    stroke: "#1C191A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8817 141.141L84.6469 134.251",
    stroke: "#1C191A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2739 61.2791C76.142 61.8801 75.9355 62.4664 75.6579 63.0274C73.2678 61.9781 73.8253 61.292 76.2739 61.2791Z",
    stroke: "#1C191A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1052 64.7756C89.0344 65.0102 88.6578 65.1632 88.021 65.2394",
    stroke: "#1C191A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2739 61.2791C76.0337 62.7503 75.188 64.0917 73.8985 65.047C68.1358 69.0875 68.0465 74.7465 72.2561 78.9815",
    stroke: "#1C191A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0225 102.146L24.5253 105.399",
    stroke: "#1C191A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8845 126.442L41.0518 129.447",
    stroke: "#1C191A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2359 131.014L33.91 133.241",
    stroke: "#1C191A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5046 107.07L17.0909 109.284",
    stroke: "#1C191A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2006 116.199L20.991 123.619",
    stroke: "#1C191A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1612 125.187L13.85 127.401",
    stroke: "#1C191A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3598 69.5023C39.8705 70.7665 37.9902 71.6123 35.9566 71.9327C33.923 72.2531 31.8274 72.0338 29.935 71.3025C28.0426 70.5711 26.4382 69.3606 25.3248 67.824C24.2114 66.2874 23.6389 64.4938 23.6798 62.6699C23.7208 60.846 24.3732 59.0737 25.5547 57.5773C26.7361 56.0808 28.3935 54.9274 30.3173 54.2628C32.2411 53.5983 34.3448 53.4525 36.3624 53.8438C38.38 54.2351 40.221 55.146 41.6524 56.4613C42.6037 57.3341 43.3508 58.364 43.851 59.492C44.3512 60.6201 44.5946 61.8242 44.5675 63.0354C44.5404 64.2466 44.2431 65.4412 43.6926 66.5508C43.1422 67.6605 42.3495 68.6635 41.3598 69.5023Z",
    stroke: "#1C191A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5561 63.4C47.797 64.76 49.7151 66.052 49.4394 66.868C48.9458 68.3416 41.6524 67.7744 33.1331 65.5984C24.6138 63.4224 18.1004 60.4624 18.5863 58.9868C18.8635 58.1443 21.3282 57.9634 24.9773 58.3653",
    stroke: "#1C191A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M72.832 73.024C73.257 75.3809 74.757 77.542 76.7767 78.1009C83.0838 79.8431 94.0062 84.0706 94.0062 84.0706C94.1425 90.7401 94.8263 98.0786 94.0948 105.749C97.5921 107.049 101.518 107.127 105.078 105.969C105.694 98.7301 106.089 91.7886 105.943 85.3783C105.91 83.783 105.492 82.2129 104.715 80.772C103.938 79.3317 102.823 78.054 101.441 77.0258C95.7426 72.8653 89.3885 69.4584 82.5794 66.9122",
    stroke: "#1C191A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0024 84.0706L95.6887 84.6276L94.1495 88.5253",
    stroke: "#1C191A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3989 100.633C97.964 101.714 101.802 101.88 105.47 101.113",
    stroke: "#1C191A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1726 12.859V15.0221",
    stroke: "#1C191A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M95.9382 17.0675H93.4888",
    stroke: "#1C191A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1726 21.2767V19.1136",
    stroke: "#1C191A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4071 17.0675H88.8572",
    stroke: "#1C191A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4888 17.0675C93.1846 17.0682 92.8828 17.0158 92.6017 16.9133C92.3199 16.8108 92.0643 16.6601 91.8495 16.47C91.6339 16.2799 91.4637 16.0542 91.3474 15.8056C91.2311 15.5572 91.1719 15.2909 91.1726 15.0221C91.1734 15.2908 91.1141 15.5571 90.9978 15.8055C90.8823 16.054 90.7114 16.2797 90.4966 16.4698C90.281 16.6599 90.0253 16.8105 89.7443 16.9131C89.4632 17.0156 89.1614 17.0681 88.8572 17.0675C89.1614 17.0669 89.4632 17.1194 89.7443 17.222C90.0261 17.3246 90.2817 17.4753 90.4966 17.6655C90.7114 17.8556 90.8823 18.0815 90.9986 18.33C91.1141 18.5785 91.1734 18.8448 91.1726 19.1136C91.1719 18.8448 91.2311 18.5784 91.3474 18.3298C91.4629 18.0813 91.6339 17.8554 91.8487 17.6652C92.0643 17.4751 92.3199 17.3244 92.601 17.2218C92.8828 17.1192 93.1846 17.0668 93.4888 17.0675Z",
    stroke: "#1C191A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesign);
export default __webpack_public_path__ + "static/media/design.b5eceb70e37b019ba708dbd6bc119e2c.svg";
export { ForwardRef as ReactComponent };